// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3auEN","detailsBorder":"styles_detailsBorder__3ndQ-"};